

import {Interaction as InteractionType} from "@/types/interaction";
import Interaction from "@/Molecules/Interaction/Interaction";
import Pagination from "@/Molecules/Pagination/Pagination";
import {usePage} from "@inertiajs/react";
import styles from "@/Organisms/Page/Obituary.module.scss";
import React from "react";

type InteractionsProps<T extends Record<string, unknown> = Record<string, unknown>> = T & {
  // interactions: InteractionType[],
  isReactionMode: boolean
  interactions: {
    data: InteractionType[],
    pages: number,
    page: number,
  },
  onAddReply: (interactionId: number, input: string) => Promise<boolean>,
  onAddHeart: (interactionId: number) => Promise<boolean>,
  onExamine?: (interactionId: number, accepted: boolean) => void,
  onInteract: (action: string) => void,
  showReviewMessage?: boolean
  asPreview?: boolean
};
export default function Interactions(
  {
    isReactionMode,
    interactions,
    onAddReply,
    onAddHeart,
    onExamine,
    // onNavigatePage,
    onInteract,
    showReviewMessage,
    asPreview
  }: InteractionsProps) {

  const handleNavigatePage = (page: number) => {
    const baseUrl = location.pathname;
    location.href = `${baseUrl}?page=${page}#interactions`
  }

  return <div className={'flex flex-col gap-3'}>

    <h2><a id={'interactions'}></a>{isReactionMode ? 'Achtergelaten reacties' : 'Condoleanceberichten'}</h2>

    {showReviewMessage && <div className={styles.alert}>
        <h3>Bedankt voor je {isReactionMode ? 'reactie' : 'condoleance'}</h3>
        <div>Voordat je bericht geplaatst wordt, wordt deze automatisch gecontroleerd of er geen ongepaste woorden
            zijn gebruikt. Indien dit niet het geval is, wordt je bericht automatisch direct geplaatst. Mocht er
            twijfel zijn, dan wordt het bericht niet zichtbaar bij de condoleances op de website. Het bericht wordt
            wel zichtbaar voor de nabestaanden in het beheeraccount. De nabestaanden kunnen dan zelf bepalen of ze het
            bericht verwijderen of wel willen opnemen op de website.
        </div>
    </div>}

    {interactions.data.length > 0 ? <>

      {interactions.data.map((interaction, index) => <Interaction
        key={index}
        {...interaction}
        onOpenReply={(input: string) => onAddReply(interaction.id, input)}
        asPreview={asPreview}
        onAddHeart={onAddHeart}
      />)}
      <Pagination page={interactions.page || 1} pages={interactions.pages} onChange={(page) => handleNavigatePage(page)} />
    </> : <div>
      Er zijn nog geen {isReactionMode ? 'reacties' : 'condoleances'} geplaatst.<br />

      {isReactionMode ? 'Reactie achterlaten' : 'Steun betuigen'}? Plaats een <a href={'#'} onClick={() => onInteract('condolence')}>{isReactionMode ? 'reactie' : 'condoleancebericht'}</a>, <a href={'#'} onClick={() => onInteract('flower')}>bloem</a> of <a href={'#'} onClick={() => onInteract('candle')}>kaarsje</a>
    </div>}


  </div>
}
